export enum UPLOAD_TYPE {
  VIDEO = 'VIDEO',
  IMAGE = 'IMAGE',
  HIGHLIGHT = 'HIGHLIGHT',
  ICON = 'ICON'
}
